import Swiper from '@src/components/swiper';
import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

export const threeCardsSwiperCards = () => {
  if ($('.swiper-cards-three-cards').length === 0) {
    return
  };

  let mySwiper;

  const generateStaticSwiper = () => {
    if (!mySwiper) {
      mySwiper = new Swiper('.swiper-cards-three-cards', {
        centeredSlides: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
            centeredSlides: false,
          },
          550: {
            spaceBetween: 48,
            slidesPerView: 2,
            centeredSlides: false,
          },
          450: {
            spaceBetween: 48,
            slidesPerView: 1.4,
            centeredSlides: false,
          },
          350: {
            spaceBetween: 48,
            slidesPerView: 1.2,
          },
          200: {
            spaceBetween: 48,
            slidesPerView: 1.2,
          }
        },
        pagination: {
          el: '.swiper-pagination-cards',
          clickable: true,
        }
      })
    }
  };

  const removeStaticSwiper = () => {
    if (mySwiper) {
      $('.swiper-cards-three-cards').each(function(){
        this.swiper.destroy();
      });
      mySwiper = null;
    }
  };

  screenResizerChecker(() => generateStaticSwiper(), () => removeStaticSwiper(), ScreensInt.lg);
};
